import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=629f6e70&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=629f6e70&prod&lang=less&"
import style1 from "./RegisterForm.vue?vue&type=style&index=1&id=629f6e70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f6e70",
  null
  
)

export default component.exports